import restApi, { restApiDP, restApiIP, restApiMP, restApiRP } from "@plannel/services/utils/rest-api";

const getAllItems = () => {
  return restApi.get("/api/items-all");
};

const getAll = params => {
  return restApi.post("/api/items", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/items/csv", params);
};

const get = id => {
  return restApi.get(`/api/items/${id}`);
};

const upsert = data => {
  return restApi.post("/api/items/save", data);
};

const remove = (ids, config) => {
  return restApi.delete(`/api/items/${ids}`, config);
};

const search = params => {
  return restApi.get("/api/search/index/item", { params })
};

const searchByIP = params => {
  return restApiIP.get("/api/search/index/item", { params })
};

const searchByDP = params => {
  return restApiDP.get("/api/search/index/item", { params })
};

const searchByMP = params => {
  return restApiMP.get("/api/search/index/item", { params })
};

const searchByRP = params => {
  return restApiRP.get("/api/search/index/item", { params })
};

const validateCodes = codes => {
  return restApi.post("/api/search/index/item/validate", codes);
};

const validateCodesByIP = codes => {
  return restApiIP.post("/api/search/index/item/validate", codes);
};

const validateCodesByDP = codes => {
  return restApiDP.post("/api/search/index/item/validate", codes);
};

const validateCodesByMP = codes => {
  return restApiMP.post("/api/search/index/item/validate", codes);
};

const validateCodesByRP = codes => {
  return restApiRP.post("/api/search/index/item/validate", codes);
};

const getItemByType = params => {
  return restApi.get("/api/items/item-type", { params })
};

const getNPIs = params => {
  return restApi.post("/api/npis", params)
};

// 홈 "신제품(NPI)" 카드 요약 — { total, missingCount, missing:[{itemCd,name,readyToSellinDt}] }
const getNpiSummary = () => {
  return restApi.get("/api/npis/summary");
};

const itemService = {
  getAllItems,
  getAll,
  getAllForCSV,
  get,
  upsert,
  remove,
  search,
  searchByIP,
  searchByDP,
  searchByMP,
  searchByRP,
  validateCodes,
  validateCodesByIP,
  validateCodesByDP,
  validateCodesByMP,
  validateCodesByRP,
  getItemByType,
  getNPIs,
  getNpiSummary
};

export default itemService;